// CategoryManagement.js
import React, { useState, useEffect } from 'react';
import { CategoryTreeProvider, useCategoryTree } from '../../context/CategoryTreeContext';
import CategoryTree from '../../components/CategoryManagement/CategoryTree';
import CategoryForm from '../../components/CategoryManagement/CategoryForm';
import CategoryDetailModal from '../../components/CategoryManagement/CategoryDetailModal';
import {
  getRootCategories,
  getCategoryChildren,
  createCategory,
  updateCategory,
  deleteCategory,
  getCategoryDetail
} from '../../services/categoryService';

// کامپوننت اصلی که از Context استفاده می‌کند
const CategoryManagement = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [formParent, setFormParent] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [categoryDetail, setCategoryDetail] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const { resetTreeState, setChildrenForCategory, getChildrenForCategory, editChildrenForCategory, createChildrenForCategory,removeChildrenForCategory } = useCategoryTree();

  const loadRootCategories = async (search = '') => {
    setLoading(true);
    try {
      const res = await getRootCategories(search);
      setCategories(res.data);
    } catch (e) {
      console.error('loadRootCategories', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRootCategories();
  }, []);

  const loadChildren = async (categoryId) => {
    try {
      // اگر قبلاً لود شده، از cache استفاده کن
      const cachedChildren = getChildrenForCategory(categoryId);
      if (cachedChildren.length > 0) {
        const hasHasProduct = cachedChildren.every(child => 'has_product' in child);
        if (hasHasProduct) {
          return cachedChildren;
        };
      };

      // در غیر این صورت از API بگیر
      const res = await getCategoryChildren(categoryId);
      setChildrenForCategory(categoryId, res.data);
      return res.data;
    } catch (e) {
      console.error('loadChildren', e);
      return [];
    }
  };

  // بقیه توابع بدون تغییر...
  const handleCreate = (parent = null) => {
    setFormParent(parent);
    setEditingCategory(null);
    setShowForm(true);
  };

  const handleEdit = (category) => {
    (async () => {
      try {
        setLoading(true);
        const res = await getCategoryDetail(category.id);
        const detail = res.data;
        console.log('اطلاعات دسته',detail)
        detail.attributes = detail.attributes || detail.category_attributes || [];
        setEditingCategory(detail);
        setFormParent(null);
        setShowForm(true);
      } catch (e) {
        console.error('handleEdit', e);
        alert('خطا در دریافت اطلاعات دسته برای ویرایش');
      } finally {
        setLoading(false);
      }
    })();
  };

  const handleView = async (category) => {
    try {
      setLoading(true);
      const res = await getCategoryDetail(category.id);
      setCategoryDetail(res.data);
      setShowDetail(true);
    } catch (e) {
      console.error('handleView', e);
      alert('خطا در دریافت جزئیات دسته');
    } finally {
      setLoading(false);
    }
  };
  const refreshAffectedCategories = (affectedCategoryIds = []) => {
    affectedCategoryIds.forEach(categoryId => {
      setChildrenForCategory(categoryId, []); // پاک کردن cache
    });
  };

  const handleDelete = async (category) => {
  if (!window.confirm(`آیا از حذف "${category.name}" مطمئن هستید؟`)) return;

  try {
    await deleteCategory(category.id);

    // اگر زیردسته است، از loadedChildren حذف کن
    if (category.parent) {
      removeChildrenForCategory(category);
    }

    // در هر حال صفحه را ریلود کن
    loadRootCategories();

  } catch (e) {
    console.error('deleteCategory', e);
    const message = e.response?.data?.error || 'خطا در حذف دسته';
    alert(message);
  }
};

  const handleSubmit = async (payload) => {
    try {
      if (editingCategory) {
        await updateCategory(editingCategory.id, payload);
        editChildrenForCategory(editingCategory.parent, editingCategory.id, payload);
      } else {
        const response = await createCategory(payload);
        const payloadWithId = {
          ...payload,
          id: response.data.id, // توجه: response.data.id
          code: response.data.code // توجه: response.data.id
        };
        createChildrenForCategory(payloadWithId);
      }
      setShowForm(false);
      setEditingCategory(null);
      setFormParent(null);
      await loadRootCategories();
    } catch (e) {
      console.error('handleSubmit', e);
      alert('خطا در ثبت دسته');
    }
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    loadRootCategories(searchTerm);
  };

  // اضافه کردن دکمه پاک کردن جستجو
  const handleClearSearch = () => {
    setSearchTerm('');
    loadRootCategories('');
  };

    return (
    <div className="p-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            {/* فرم جستجو */}
            <form onSubmit={handleSearchSubmit} className="flex-1 w-full sm:max-w-md">
              <div className="relative w-[500px]">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={handleSearch}
                  placeholder="جستجو بر اساس عنوان، توضیحات یا کد دسته..."
                  className="w-full pr-10 pl-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <button
                  type="submit"
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                  </svg>
                </button>
                {searchTerm && (
                  <button
                    type="button"
                    onClick={handleClearSearch}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                  </button>
                )}
              </div>
            </form>
          </div>
          <div>
            <button onClick={() => handleCreate()} className="bg-[#1E3A5F] text-[#FFC107] hover:bg-[#2B5388] hover:text-[#D19D00] px-4 py-2 rounded">
              افزودن دسته جدید
            </button>

          </div>
        </div>

        {/* نمایش وضعیت جستجو */}
        {searchTerm && (
          <div className="mb-4 p-3 bg-blue-50 rounded-lg">
            <div className="flex items-center justify-between">
              <span className="text-blue-700">
                نتایج جستجو برای: "<strong>{searchTerm}</strong>"
              </span>
              <button
                onClick={handleClearSearch}
                className="text-blue-600 hover:text-blue-800 text-sm"
              >
                نمایش همه دسته‌ها
              </button>
            </div>
          </div>
        )}

        <CategoryTree
          categories={categories}
          loading={loading}
          onLoadChildren={loadChildren}
          onAddChild={(parent) => handleCreate(parent)}
          onEdit={handleEdit}
          onView={handleView}
          onDelete={handleDelete}
          isSearchMode={!!searchTerm} // برای تغییر رفتار در حالت جستجو
        />
        {showForm && (
            <CategoryForm
                category={editingCategory}
                parentCategory={formParent}
                onSubmit={handleSubmit}
                onCancel={() => {
                  setShowForm(false);
                  setEditingCategory(null);
                  setFormParent(null);
                }}
            />
        )}

        {showDetail && (
            <CategoryDetailModal
                categoryDetail={categoryDetail}
                onClose={() => {
                  setShowDetail(false);
                  setCategoryDetail(null);
                }}
                onEdit={(cat) => {
                  setShowDetail(false);
                  handleEdit({id: cat.id, name: cat.name, code: cat.code});
                }}
            />
        )}
      </div>
    </div>
  );
};


export default CategoryManagement;